import React from "react";
import { BlueBtn } from "components/Controls";
import "./styles.scss";

const CTAFooter = ({ helperText, hintText, ctaText, disabled, onClick, errorText }) => (
  <div className="cart-cta">
    {errorText && <div className="cart-cta__error">{errorText}</div>}
    {helperText && <div className="cart-cta__helper">{helperText}</div>}
    {hintText && <div className="cart-cta__hint">{hintText}</div>}
    <BlueBtn
      isExpanded
      disabled={disabled}
      customClass="cart-cta__btn"
      onClick={onClick}
    >
      {ctaText}
    </BlueBtn>
  </div>
);

export default CTAFooter;
